import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import FormControl from '@material-ui/core/FormControl'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { tableTypesMatcher } from 'utils/labelMatcher'
const styles = theme => ({
  formControl: {
    margin: `0 ${theme.spacing.unit}px`,
    minWidth: 140
  },
  gridSeparator: {
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  }
})

export default withStyles(styles)(
  class BillardConfigurationComponent extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      updatePricing: PropTypes.func.isRequired,
      tableTypes: PropTypes.object,
      pricing: PropTypes.object
    }

    static defaultProps = {
      pricing: {
        american: '0',
        carom: '0',
        chinese: '0',
        snooker: '0',
        pool: '0'
      },
      tableTypes: {
        american: false,
        carom: false,
        chinese: false,
        snooker: false,
        pool: false
      }
    }
    handleChange = name => event => {
      this.props.updatePricing(name, event.target.value)
    }
    formComponents = tableTypes => {
      const { classes, pricing } = this.props
      const tableTypesEnabled = Object.keys(tableTypes).filter(
        key => tableTypes[key]
      )
      return tableTypesEnabled.map(key => {
        const label = tableTypesMatcher(key)
        return (
          <Grid key={key} item xs={10} sm={8} md={5}>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor={`${key}-input`}>{label}</InputLabel>
              <Input
                id={`${key}-input`}
                value={pricing[key]}
                onChange={this.handleChange(key)}
                endAdornment={
                  <InputAdornment position="end">€/heure</InputAdornment>
                }
                inputProps={{
                  'aria-label': 'Prix'
                }}
              />
            </FormControl>
          </Grid>
        )
      })
    }
    render() {
      const { tableTypes } = this.props
      return (
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="stretch"
          alignContent="stretch"
          spacing={8}>
          <Grid item xs={10} sm={8} md={12}>
            <Typography variant="subheading">
              Quel est votre tarif horaire normal ?
            </Typography>
            <Typography variant="caption">
              Le tarif normal est en génrale le tarif qui est utilisé le plus
              régulièrement pendant la semaine
            </Typography>
          </Grid>
          <Grid item xs={10} sm={8} md={12}>
            <Divider light />
          </Grid>

          {this.formComponents(tableTypes).map(comp => comp)}
        </Grid>
      )
      // return
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/DashpoolConfiguration/PricingConfigurationComponent.js